module.exports = __webpack_public_path__ + "img/264.292250fa.jpg";